import { GitBranch, Check, AlertCircle } from "lucide-react";
import { Card } from "@/components/ui/card";
import { Badge } from "@/components/ui/badge";
import { StatusDot } from "@/components/ui/status-dot";

interface GitBranchData {
  branch: string;
  clean: boolean;
  ahead: number;
  behind: number;
  change_count: number;
}

interface GitBranchWidgetProps {
  data: GitBranchData;
}

export function GitBranchWidget({ data }: GitBranchWidgetProps) {
  const { branch = "unknown", clean = true, ahead = 0, behind = 0, change_count = 0 } = data ?? {};

  return (
    <Card variant="default" padding="sm" className="max-w-md animate-slide-up">
      <div className="flex items-center gap-3">
        <div className="flex items-center justify-center h-8 w-8 rounded-lg bg-daydra-accent-ghost shrink-0">
          <GitBranch size={16} className="text-daydra-accent" />
        </div>
        <div className="flex-1 min-w-0">
          <p className="text-sm font-medium text-daydra-text truncate">{branch}</p>
          <div className="flex items-center gap-2 mt-0.5">
            <StatusDot
              status={clean ? "connected" : "warning"}
              size="sm"
              label={clean ? "Clean" : `${change_count} change${change_count !== 1 ? "s" : ""}`}
              labelHidden={false}
            />
            {ahead > 0 && (
              <Badge variant="accent" size="sm">{ahead} ahead</Badge>
            )}
            {behind > 0 && (
              <Badge variant="warning" size="sm">{behind} behind</Badge>
            )}
          </div>
        </div>
        {clean ? (
          <Check size={18} className="text-daydra-success shrink-0" />
        ) : (
          <AlertCircle size={18} className="text-daydra-warning shrink-0" />
        )}
      </div>
    </Card>
  );
}
